import React from 'react';

export type Classification = 'client' | 'internal' | 'unclear' | null;
export type ClassificationMethod = 'rule' | 'match' | 'llm' | 'manual' | null;

interface Props {
  classification: Classification;
  method?: ClassificationMethod;
  confidence?: number | null;
  size?: 'sm' | 'md';
}

const COLORS: Record<string, { bg: string; fg: string; label: string }> = {
  client:   { bg: '#dcfce7', fg: '#166534', label: 'Klient' },
  internal: { bg: '#e5e7eb', fg: '#374151', label: 'Interné' },
  unclear:  { bg: '#fef3c7', fg: '#92400e', label: 'Nejasné' },
};

const METHOD_LABEL: Record<string, string> = {
  rule: 'pravidlo',
  match: 'match',
  llm: 'AI',
  manual: 'manuál',
};

const ClassificationBadge: React.FC<Props> = ({ classification, method, confidence, size = 'md' }) => {
  if (!classification) {
    return (
      <span style={{
        display: 'inline-block',
        padding: size === 'sm' ? '2px 6px' : '4px 10px',
        background: '#f3f4f6',
        color: '#6b7280',
        borderRadius: 4,
        fontSize: size === 'sm' ? 11 : 12,
        fontWeight: 500,
      }}>
        nezatriedené
      </span>
    );
  }

  const cfg = COLORS[classification] || COLORS.unclear;
  const methodLabel = method ? METHOD_LABEL[method] || method : null;
  const confPct = typeof confidence === 'number' ? `${Math.round(confidence * 100)} %` : null;
  const tooltipParts = [methodLabel, confPct].filter(Boolean);
  const tooltip = tooltipParts.length > 0 ? tooltipParts.join(' · ') : undefined;

  return (
    <span
      title={tooltip}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: size === 'sm' ? '2px 6px' : '4px 10px',
        background: cfg.bg,
        color: cfg.fg,
        borderRadius: 4,
        fontSize: size === 'sm' ? 11 : 12,
        fontWeight: 600,
        whiteSpace: 'nowrap',
      }}
    >
      {cfg.label}
      {methodLabel && (
        <span style={{ fontWeight: 400, opacity: 0.75, fontSize: size === 'sm' ? 10 : 11 }}>
          · {methodLabel}
        </span>
      )}
    </span>
  );
};

export default ClassificationBadge;
